module.exports = __webpack_public_path__ + "7c9bdc70f9754f14a756bd60c8ae2c27.jpg";